/* linguist-generated */
/* eslint-disable */
// Generated code. Do not modify.
// To add additional endpoints, please add them to your api-gateway protos and
// re-run yarn nx run instant-api-hooks-<module>:codegen
//
import { CONSOLE_PREFIX, CONSOLE_STYLE } from '@cbhq/instant-api-hooks-core/util';

/**
      * - UNKNOWN: Janus defined statuses
UNKNOWN is the default unspecified status
 - INACTIVE: INACTIVE indicates the second factor is not active
 - INITIATED: INITIATED indicates the second factor flow has been started
 - PENDING: PENDING indicates the second factor is awaiting completion
 - ACTIVE: ACTIVE indicates the second factor is active and in use
 - ENABLED: ENABLED indicates the second factor is enabled for the user
 - ACTIVATED: ACTIVATED indicates the second factor has been activated
 - CANCELLED: CANCELLED indicates the second factor flow was cancelled
 - DELETED: DELETED indicates the second factor has been deleted
 - DISABLED: DISABLED indicates the second factor has been disabled
 - NEW: Core IDV statuses
NEW indicates a newly created IDV record
 - SUCCESS_PENDING_CHOICE: SUCCESS_PENDING_CHOICE indicates IDV succeeded and awaiting user choice
 - COMPLETED: COMPLETED indicates the IDV process has completed
 - FAILED: FAILED indicates the IDV process has failed
 - FALLING_BACK: FALLING_BACK indicates the IDV process is falling back to an alternative method
 - CONSUMED: Recovery Code Specific
CONSUMED indicates the recovery code has been used
 - MIGRATION_DISABLED: Migration for MFA
MIGRATION_DISABLED indicates the second factor is disabled due to migration
 - AUTO_ENABLED: Push auto-enroll
AUTO_ENABLED indicates the second factor was enrolled automatically by a
background processor (e.g. Push auto-enroll) rather than chosen by the user.
It is deliberately distinct from ENABLED so the auto-enrolled cohort can be
measured, gated behind an experiment, and rolled back independently. It must
NOT be treated as ENABLED by the global "is enabled" check — callers opt in
explicitly where an auto-enrolled factor should behave as enabled.
      * @Example No example provided
      */
export enum CoinbaseJanusSecondfactorsSecondFactorsStatus {
  UNKNOWN = 'UNKNOWN',
  INACTIVE = 'INACTIVE',
  INITIATED = 'INITIATED',
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  ENABLED = 'ENABLED',
  ACTIVATED = 'ACTIVATED',
  CANCELLED = 'CANCELLED',
  DELETED = 'DELETED',
  DISABLED = 'DISABLED',
  NEW = 'NEW',
  SUCCESS_PENDING_CHOICE = 'SUCCESS_PENDING_CHOICE',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  FALLING_BACK = 'FALLING_BACK',
  CONSUMED = 'CONSUMED',
  MIGRATION_DISABLED = 'MIGRATION_DISABLED',
  AUTO_ENABLED = 'AUTO_ENABLED',
}
export const getCoinbaseJanusSecondfactorsSecondFactorsStatusErrors = (
  value: unknown,
): { fieldName: string; error: string }[] => {
  if (process.env.NODE_ENV === 'production') return [];
  if (!Object.values(CoinbaseJanusSecondfactorsSecondFactorsStatus).includes(value as any)) {
    return [
      {
        fieldName: '',
        error: ` ${value} is not a valid CoinbaseJanusSecondfactorsSecondFactorsStatus.`,
      },
    ];
  } else {
    return [];
  }
};

const validateCoinbaseJanusSecondfactorsSecondFactorsStatus = (value: unknown) => {
  const errors = getCoinbaseJanusSecondfactorsSecondFactorsStatusErrors(value);
  if (errors.length) {
    console.error(
      CONSOLE_PREFIX,
      CONSOLE_STYLE,
      `API Error: CoinbaseJanusSecondfactorsSecondFactorsStatus data does not match contract.`,
      errors,
    );
  }
};
